export default __webpack_public_path__ + "static/media/temple.96301a4d.webp";